/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MembershipsInputs */

const en__field_memberships = /** @type {(inputs: _Field_MembershipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizations`)
};

/** @type {(inputs: _Field_MembershipsInputs) => LocalizedString} */
const de__field_memberships = en__field_memberships;

/**
* | output |
* | --- |
* | "Organizations" |
*
* @param {_Field_MembershipsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_memberships = /** @type {((inputs?: _Field_MembershipsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MembershipsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_memberships(inputs)
	return de__field_memberships(inputs)
});